import util from '@bmp-vue/core/api/util'

const controller = 'WebhookRecebido'
export default Object.assign({}, util.GetCrud(controller, ['getall']))
